import { createAction } from '@reduxjs/toolkit';
import { statusList, statuses } from '~/config/settings/notification.settings';

const createNotification = createAction(
  'notifications/createNotification',
  ({ title = null, message = '', status = statuses.info }) => {
    const validatedStatus = statusList.includes(status) ? status : statuses.info;
    const validatedTitle = title !== null ? title : validatedStatus.charAt(0).toUpperCase() + validatedStatus.slice(1); // Titleized

    const notification = {
      title: validatedTitle,
      message,
      status: validatedStatus,
    };

    return {
      payload: {
        notification,
      },
    };
  },
);

const showNotifications = createAction('notifications/showNotifications');

const dismissNotification = createAction('notifications/dismissNotification', (notificationId) => ({
  payload: {
    id: notificationId,
  },
}));

export const notificationActions = {
  createNotification,
  showNotifications,
  dismissNotification,
};
